import axios from "@/utils/request";
export const taskPage=(data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/page",
        data
    })
}
export const taskDetail=(taskId:string)=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/get/"+ taskId,
    })
}

export const exeTask=(data:any,taskMedicalId:string,temStore:boolean)=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/exeTask/" + taskMedicalId + "?temStore=" + temStore,
        method:"POST",
        data
    })
}

export const exeForward=(data:any,taskMedicalId:string)=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/editSubMedical/" + taskMedicalId,
        method:"POST",
        data
    })
}

export const downTask=(data:any,taskId:string)=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/downTask/" + taskId,
        method:"POST",
        data
    })
}


export const downTaskVillages=()=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/downTaskVillages"
    })
}

export const downTaskItems=(taskId:string)=>{
    return axios({
        path:"/onlineMedical/medicalComp/task/downTaskItems/" + taskId,
    })
}
